<template>
  <div v-if="current">

    <v-row>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.name }}</td>
          <td>
            <v-btn icon @click="edit(item.id)" title="Editar"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn icon @click="dialogNps(item.id)" title="NPS"><v-icon>mdi-speedometer</v-icon></v-btn>
            <v-btn icon @click="dialogRemove(item)" title="Excluir"><v-icon>mdi-delete</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialog_nps" max-width="700px">
      <v-card width="100%" v-if="nps">
        <v-card-title>NPS</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Parceiro recebido</th>
                <th>Parceiro conhecido</th>
                <th>Nota recebida</th>
                <th>Nota reconhecida</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in nps" :key="item.id">
                <td>{{ item.created | formatDate }} {{ item.created | formatTime}}</td>
                <td>{{ item.partnerReceived }}</td>
                <td>{{ item.partnerKnownName }}</td>
                <td>{{ item.scoreReceived }}</td>
                <td>{{ item.scoreKnown }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_remove" max-width="400px">
      <v-card width="100%" v-if="removing">
        <v-card-title>Confirmar exclusão</v-card-title>
        <v-card-text>
          Deseja realmente excluir o parceiro <strong>{{ removing.name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_remove = false">Cancelar</v-btn>
          <v-btn color="error" @click="remove()">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: function () {
    return {
      current: null,
      nps: [],
      dialog_nps: false,
      removing: null,
      dialog_remove: false
    };
  },
  created: function () {
    this.list();
  },
  methods: {
    list: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/partner", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function () {
          console.log("user fail");
        });
    },
    register: function () {
      router.push({ path: `/partner/0` });
    },
    edit: function (id) {
      router.push({ path: `/partner/${id}` });
    },
    dialogNps: function(id){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nps/partner/"+id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.nps = response.data;
          me.dialog_nps = true;
        })
        .catch(function () {
          console.log("user fail");
        });
    },
    dialogRemove: function (item) {
      this.removing = item;
      this.dialog_remove = true;
    },
    remove: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .delete("/partner/" + this.removing.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_remove = false;
          me.removing = null;
          me.list();
        })
        .catch(function () {
          console.log("remove fail");
        });
    }
  }
};
</script>